import clsx from 'clsx';
import ReactCountryFlag from 'react-country-flag';

import { DataTestIds } from '@repo/frontend-shared/data-test-ids';
import { SDSChevronIcon } from '@repo/sds/SDSChevronIcon';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import { COUNTRIES, countryCallingCode } from '../../constants/countries';

import './CountryButton.scss';

interface CountryButtonProps {
  compact?: boolean;
  dataTestId?: string;
  display?: 'callingCode' | 'name';
  isOpen: boolean;
  onClick: () => void;
  placeholder?: string;
  selectedCountry?: string;
  showFlag?: boolean;
}

export function CountryButton({
  compact = false,
  dataTestId = DataTestIds.ONBOARDING.COUNTRY_SELECT,
  display = 'name',
  isOpen,
  onClick,
  placeholder = 'Select country',
  selectedCountry,
  showFlag = true,
}: CountryButtonProps) {
  const country = selectedCountry ? COUNTRIES.find(c => c.code === selectedCountry) : null;
  const label =
    display === 'callingCode'
      ? selectedCountry
        ? countryCallingCode(selectedCountry)
        : placeholder
      : country?.name || placeholder;

  return (
    <SDSPrimitiveButton
      className={clsx('CountryButton', compact && 'CountryButton--compact')}
      dataTestId={dataTestId}
      onClick={onClick}
    >
      <SDSFlexbox direction="row" fullWidth={!compact} gap={compact ? 'text-small' : 'button-regular'}>
        {showFlag && selectedCountry && (
          <ReactCountryFlag
            aria-label={country?.name || selectedCountry}
            countryCode={selectedCountry}
            style={{
              borderRadius: '2px',
              height: '1.125rem',
              width: '1.5rem',
            }}
            svg
          />
        )}
        <SDSText className="CountryButton__text" text={label} type="body-medium" />
      </SDSFlexbox>

      <SDSChevronIcon isExpanded={isOpen} />
    </SDSPrimitiveButton>
  );
}
